/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_header = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {

		/*
		Colors: Remove
		*/
		$('.js-color-1').removeClass('color-1a color-1b color-1c color-1d');
		$('.js-color-2').removeClass('color-1a color-1b color-1c color-1d');

		/*
		Colors: Set
		*/
		switch(url[1]) {

			default:

				$('.js-color-1').addClass('color-1a');
				$('.js-color-2').addClass('color-1b');

			break;

			case 'ervaringen':

				$('.js-color-1').addClass('color-1a');
				$('.js-color-2').addClass('color-1c');

			break;

			case 'doula':

				$('.js-color-1').addClass('color-1a');
				$('.js-color-2').addClass('color-1c');

			break;

			case 'contact':

				$('.js-color-1').addClass('color-1a');
				$('.js-color-2').addClass('color-white');

			break;

		}

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none

}).apply(specific_header); 